import { TransactionSuccessToast } from "@/components";
import type { TransactionHash } from "@/types";
import { ToastSimpleRow } from "./ToastSimpleRow";

interface MultivoteSuccessToastProps {
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function MultivoteSuccessToast({ transactionHash, onClose }: MultivoteSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Vote successfully cast" transactionHash={transactionHash} onClose={onClose}>
            <ToastSimpleRow label="Voted" />
        </TransactionSuccessToast>
    );
}
